import { render, staticRenderFns } from "./FooterClear.vue?vue&type=template&id=c5ef944a&"
import script from "./FooterClear.vue?vue&type=script&lang=ts&"
export * from "./FooterClear.vue?vue&type=script&lang=ts&"
import style0 from "./FooterClear.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import QToolbar from 'quasar/src/components/toolbar/QToolbar.js';
import QSpace from 'quasar/src/components/space/QSpace.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QSeparator,QToolbar,QSpace,QBtn});
